import { useCallback, useRef } from 'react';

/**
 * Files removed from the Files strip in this session, per inquiry. The API
 * may still list them for a while, so every payload is filtered with them.
 */
export const useRemovedFiles = () => {
  const removedRef = useRef(new Map<string, Set<string>>());

  const removedFileIdsFor = useCallback((inquiryId: unknown) => {
    const key = String(inquiryId);
    let ids = removedRef.current.get(key);
    if (!ids) {
      ids = new Set();
      removedRef.current.set(key, ids);
    }
    return ids;
  }, []);

  return removedFileIdsFor;
};
